module.exports = __webpack_public_path__ + "static/media/wix.84b75135.svg";